import { ListProps, default as MuiList } from '@mui/material/List'
import * as React from 'react'

type ListRef = HTMLElementTagNameMap['ul']

// eslint-disable-next-line no-shadow
const List = React.forwardRef<ListRef, ListProps>(function List(props, ref) {
  return <MuiList {...props} disablePadding ref={ref} />
})

export { ListProps }

export default List
